import { forwardRef, type ButtonHTMLAttributes } from "react";
import { cn } from "../../lib/format";

type Variant = "primary" | "outline" | "ghost" | "ink";
type Size = "sm" | "md" | "lg";

export const Button = forwardRef<
  HTMLButtonElement,
  ButtonHTMLAttributes<HTMLButtonElement> & { variant?: Variant; size?: Size }
>(function Button({ variant = "primary", size = "md", className, ...props }, ref) {
  const v = {
    primary:
      "bg-terracotta text-paper hover:bg-terracotta-soft hover:-translate-y-px hover:shadow-[0_6px_18px_-6px_rgba(184,71,44,0.4)]",
    outline: "border border-ink text-ink hover:bg-ink hover:text-paper",
    ghost: "text-ink hover:bg-terracotta-tint hover:text-terracotta",
    ink: "bg-ink text-paper hover:bg-ink-soft",
  }[variant];
  const s = {
    sm: "px-3 py-1.5 text-sm",
    md: "px-5 py-3 text-[0.95rem]",
    lg: "px-7 py-4 text-base",
  }[size];
  return (
    <button
      ref={ref}
      className={cn(
        "inline-flex items-center justify-center gap-2 rounded font-medium whitespace-nowrap transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed",
        v,
        s,
        className,
      )}
      {...props}
    />
  );
});
